export default {
  paged: {
    select: 'id,type,name,description,isActive,validated,isPublic',
    searchSelect: ['name', 'description'],
    expand: {
      group: { select: 'name' },
    },
  },
  item: {
    select: 'id,type,name,description,isActive,isPublic,permissions,groupId,serverId',
    expand: {
      group: { select: 'name' },
      server: { select: 'name' },
      collaborators: { select: 'id', expand: { collaborator: { select: 'id,fullName' } } },
    },
  },
  itemDetail: {
    select:
      'id,type,name,description,isActive,isPublic,validated,permissions,configurations,created,updated,creator,modifier',
    expand: {
      group: { select: 'name' },
      server: { select: 'name' },
      collaborators: { select: 'id', expand: { collaborator: { select: 'id,fullName' } } },
    },
  },
};
